import { Heart } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Rsvp({ datos, seccion, acciones }) {
  const rsvp = datos.rsvp || {};

  return (
    <section className="bt-seccion bt-rsvp" aria-label={seccion.titulo}>
      <div className="bt-seccion-interior">
        <EncabezadoSeccion p="bt" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="bt-titulo-rsvp" />
        <Reveal delay={0.1}>
          {rsvp.mensaje && <p className="bt-rsvp-mensaje">{rsvp.mensaje}</p>}
          {rsvp.fechaLimite && <p className="bt-rsvp-limite">{rsvp.fechaLimite}</p>}
          <button
            type="button"
            className="bt-boton bt-boton--claro"
            onClick={() => acciones?.onConfirmarAsistencia?.()}
            data-testid="bt-boton-rsvp"
          >
            <Heart strokeWidth={1.5} />
            {rsvp.textoBoton || "Confirmar asistencia"}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
